<template>
  <section class="-mt-16 pt-36 md:pt-48 pb-20 md:pb-32" :class="isDark ? 'bg-gray-900' : 'bg-gradient-to-br from-green-50 via-blue-50 to-white'">
    <div class="max-w-6xl mx-auto px-6">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div class="inline-flex items-center space-x-2 px-4 py-2 rounded-full mb-6"
               :class="isDark ? 'bg-green-500/20' : 'bg-green-100'">
            <span class="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
            <span class="text-sm font-medium" :class="isDark ? 'text-green-400' : 'text-green-600'">系统架构设计师</span>
          </div>
          <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" :class="isDark ? 'text-white' : 'text-gray-800'">
            Hello, I'm <span class="text-green-500">PANZHIJIE</span>.
          </h1>
          <p class="text-lg mb-8 font-medium bg-clip-text text-transparent bg-gradient-to-r"
             :class="isDark
               ? 'from-pink-400 via-purple-400 to-blue-400'
               : 'from-red-500 via-yellow-500 to-green-500'">
            $ echo "日拱一卒，功不唐捐。"
          </p>
          <div class="flex flex-wrap gap-4">
            <a href="#blog" class="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors">
              浏览博客
            </a>
            <router-link to="/about" class="px-6 py-3 border rounded-lg transition-colors"
               :class="isDark ? 'border-gray-600 hover:border-green-500 text-gray-300 hover:text-green-400' : 'border-gray-300 hover:border-green-500 text-gray-600 hover:text-green-600'">
              了解更多
            </router-link>
          </div>
          <div class="flex items-center space-x-6 mt-10">
            <div class="text-center">
              <p class="text-2xl font-bold text-green-500">100+</p>
              <p class="text-sm" :class="isDark ? 'text-gray-500' : 'text-gray-400'">文章</p>
            </div>
            <div class="w-px h-12" :class="isDark ? 'bg-gray-700' : 'bg-gray-200'"></div>
            <div class="text-center">
              <p class="text-2xl font-bold text-green-500">15年</p>
              <p class="text-sm" :class="isDark ? 'text-gray-500' : 'text-gray-400'">经验</p>
            </div>
            <div class="w-px h-12" :class="isDark ? 'bg-gray-700' : 'bg-gray-200'"></div>
            <div class="text-center">
              <p class="text-2xl font-bold text-green-500">50K+</p>
              <p class="text-sm" :class="isDark ? 'text-gray-500' : 'text-gray-400'">浏览量</p>
            </div>
          </div>
        </div>
        <div class="relative">
          <div class="rounded-xl overflow-hidden shadow-2xl border" :class="isDark ? 'border-gray-700' : 'border-gray-200'">
            <!-- Terminal header -->
            <div class="flex items-center space-x-2 px-4 py-3" :class="isDark ? 'bg-gray-800' : 'bg-gray-100'">
              <span class="w-3 h-3 rounded-full bg-red-500"></span>
              <span class="w-3 h-3 rounded-full bg-yellow-500"></span>
              <span class="w-3 h-3 rounded-full bg-green-500"></span>
              <span class="ml-4 text-xs font-mono" :class="isDark ? 'text-gray-400' : 'text-gray-500'">panzhijie@panzhijie.cn ~ </span>
            </div>
            <!-- Terminal content -->
            <div class="p-6 font-mono text-sm" :class="isDark ? 'bg-gray-950' : 'bg-white'">
              <div class="space-y-2">
                <div :class="isDark ? 'text-gray-500' : 'text-gray-400'">
                  <span :class="isDark ? 'text-green-400' : 'text-green-600'">panzhijie@panzhijie.cn</span>
                  <span :class="isDark ? 'text-gray-400' : 'text-gray-500'">:</span>
                  <span :class="isDark ? 'text-blue-400' : 'text-blue-500'">~</span>
                  <span :class="isDark ? 'text-gray-400' : 'text-gray-500'">$</span>
                  <span :class="isDark ? 'text-gray-300' : 'text-gray-700'"> cat about.txt</span>
                </div>
                <div :class="isDark ? 'text-gray-300' : 'text-gray-700'" class="mt-2">
                  <p class="mb-2"><span :class="isDark ? 'text-green-400' : 'text-green-600'">Domain:</span> panzhijie.cn</p>
                  <p class="mb-2"><span :class="isDark ? 'text-green-400' : 'text-green-600'">Author:</span> PANZHIJIE</p>
                  <p class="mb-2"><span :class="isDark ? 'text-green-400' : 'text-green-600'">Role:</span> System Architect Designer</p>
                  <p class="mb-2"><span :class="isDark ? 'text-green-400' : 'text-green-600'">Skills:</span> Java, Spring, Vue, Jenkins</p>
                  <p class="mb-2"><span :class="isDark ? 'text-green-400' : 'text-green-600'">Motto:</span> One can only rely on oneself.</p>
                </div>
                <div :class="isDark ? 'text-gray-500' : 'text-gray-400'">
                  <span :class="isDark ? 'text-green-400' : 'text-green-600'">panzhijie@panzhijie.cn</span>
                  <span :class="isDark ? 'text-gray-400' : 'text-gray-500'">:</span>
                  <span :class="isDark ? 'text-blue-400' : 'text-blue-500'">~</span>
                  <span :class="isDark ? 'text-gray-400' : 'text-gray-500'">$</span>
                  <span class="inline-block w-2 h-4 ml-1 animate-pulse align-middle" :class="isDark ? 'bg-green-400' : 'bg-green-600'"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'Hero',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  }
}
</script>

<style scoped>
.bg-gray-950 {
  background-color: rgb(10 10 10);
}
</style>